<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col equal-height :span="12" md12 sm24 v-for="(position, index) in positions" :key="index">
        <card full-height :overflow-off="false" align="center" v-tooltip="{position, text: $lang.tooltip(position)}">
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">{{ $lang.tooltip(position).toUpperCase() }}</card-title>
          <card-text :class="['p-4']">
            <code-chunk :pre="false">v-tooltip="{{ JSON.stringify({position, text: $lang.tooltip(position)}).replace(/"/g, '\'').replace(/:/g, ': ') }}"</code-chunk>
          </card-text>
        </card>
      </flex-col>
    </flex>
    <all-section-blocks :title="false" :tooltip="true" />
  </container>
</template>
<script>
export default {
  name: 'PageTooltip',
  data () {
    return {
      positions: ['left', 'top', 'right', 'bottom']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/directives/tooltip.vue